import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const contractService ={
    async getAllContracts(params){
        try{
            return await $api.get(`${API_URL}/contract/list`, { params })
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },
    async createContract(data,id){
        try{
            return await $api.post(`${API_URL}/direction/hospital/${id}/contracts`, {...data})
        } catch(error){
           errorMessage(error, error?.response?.data?.message); 
        }
    },
    async getContract(id){
        try{
            return await $api.get(`${API_URL}/contract/${id}`)
        } catch(error){
           errorMessage(error, error?.response?.data?.message); 
        }
    },
    async getDepartmentsByClinic(id){
        try{
            return await $api.get(`${API_URL}/direction/hospital/${id}/departments`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },async getCompleteHospital(id){
        try{
            return await $api.get(`${API_URL}/direction/hospital/${id}`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },
     async updateContract(id, data){
        try{
            return await $api.put(`${API_URL}/contract/${id}`, {...data})
        } catch(error){
           errorMessage(error, error?.response?.data?.message); 
        }
    },
    async addAgreements(id, data){
        try{
            return await $api.put(`${API_URL}/contract/${id}/additional-agreements`, {...data})
        } catch(error){
           errorMessage(error, error?.response?.data?.message); 
        }
    },
     async updateAgreements(id, data){
        try{
            return await $api.put(`${API_URL}/contract/${id}/agreements`, {...data})
        } catch(error){
           errorMessage(error, error?.response?.data?.message); 
        }
    },
    async getStatistic(hosp, contr, start, end, status, type, level) {
        try {
            const params = {
                startDate: start,
                endDate: end,
                research: type,
                status: status
            };

            // додай рівень складності лише для гістології
            if (type === 'Гістологія') {
                params.difficultyLevel = level;
            }

            return await $api.get(`${API_URL}/statistic/hospital/${hosp}/contracts/${contr}`, { params });
        } catch (error) {
            errorMessage(error, error?.response?.data?.message);
        }
    },
    async getHospitalContracts(id){
        try{
            return await $api.get(`${API_URL}/direction/hospital/${id}/contracts`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message); 
        }
    }
}